'use client';

import { ReactElement } from 'react';
import { Navigate } from 'react-router-dom';
import useAuth from './Redux/useAuth';

interface RestrictedRouteProps {
  component: ReactElement;
  redirectTo?: string;
}

const RestrictedRoute = ({ component, redirectTo = '/' }: RestrictedRouteProps) => {
  const { isLoggedIn } = useAuth();
  return isLoggedIn ? <Navigate to={redirectTo} /> : component;
};

export default RestrictedRoute;
